<template>
  <div v-if="dataHasLoaded" class="dashboard team-theme">
    <section>
      <div class="container">
        <button class="btn btn-default-back back-button" onclick="window.history.back()">
          Back
        </button>

        <div class="row row-border-bottom">
          <div class="col-sm-10 col-xs-9 header-col">
            <h2 class="header-padding">
              Members
              <router-link
                v-if="canInvite"
                tag="a"
                :to="`/team/invite/${id}`"
                class="btn btn-md btn-primary text-center"
                style="margin-left: 20px"
                data-test="invite-button"
                event=""
                >Invite</router-link
              >
            </h2>
          </div>
          <div class="col-sm-2 col-xs-3 image-col">
            <img
              data-test="team-members-icon"
              class="team-icon"
              src="../../assets/team-members-icon.svg"
              alt="team members page"
            />
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <GroupMemberTable :model="currentAndPendingMembers" :teamId="id" />
          </div>
        </div>
      </div>
      <div style="height: 80px"></div>
    </section>
  </div>

  <LoadingPage v-else />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useAxios } from "../../composables/api";
import GroupMemberTable from "../../components/group-member-table/group-member-table.vue";
import { TeamCurrentAndPendingMembersApiModel, TeamSettingsApiModel } from "../../api-models";
import LoadingPage from "../loading-page.vue";

const props = defineProps<{ id: string }>();

// Fetched data needs to be declared here before any code that is trying to access the variables
const { data: teamSettingsModel } = useAxios<TeamSettingsApiModel>(`/api/teamsettings/${props.id}`);
const { data: currentAndPendingMembers } = useAxios<TeamCurrentAndPendingMembersApiModel>(
  `/api/teammembership/${props.id}`,
);

const canInvite = computed(() => !!teamSettingsModel.value?.userPermissions.canInviteToGroup);
const dataHasLoaded = computed(() => !!teamSettingsModel.value && !!currentAndPendingMembers.value);
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "../../styles/dashboards/dashboards";

.header-col {
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.header-padding {
  padding-left: 5rem;

  @media (max-width: @screen-sm) {
    padding-left: 0;
  }
}

.row-border-bottom {
  border-bottom: 1px solid #eeeeee;
}

.back-button {
  margin: 10px 0 -10px;
  //margin-top: 10px;

  @media (min-width: 1440px) {
    position: absolute;
    margin-top: 35px;
    margin-left: calc(-150px + @side-nav-collapsed-width);
  }
}

.image-col {
  display: flex;
  justify-content: flex-end;
  height: 100px;

  @media (max-width: @screen-xs) {
    justify-content: center;
    align-items: center;
  }
}
.team-icon {
  width: 100px;

  @media (max-width: @screen-xs) {
    width: 80px;
    height: 80px;
  }
}

@media (max-width: @screen-mobile-md) {
  .image-col {
    display: none;
  }

  .header-col {
    width: 100%;
  }
}
</style>
